import { ThemeUICSSObject } from '@apia/theme';

export const containerWithHeader: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '7px',
  overflow: 'hidden',
  maxHeight: '100%',
  position: 'relative',
  top: 'auto',
  left: 'auto',
  width: 'auto',
  height: 'auto',
  zIndex: 'auto',
  backgroundColor: 'none',
  '&.fullScreen': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 100,
    backgroundColor: 'white',
  },

  '.container__header': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px',
    borderBottom: '1px solid lightgray',
    alignItems: 'center',
    boxShadow: 'rgba(100, 98, 88, 0.2) 0px 0px 7px 0px',
    position: 'sticky',
    top: '0',
    zIndex: 1,
    background: 'white',
    flexShrink: 0,
  },
  '.container__rightButtons': {
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
    button: {
      width: '40px',
      height: '40px',
      background: 'transparent',
      border: 'none',
      p: '10px !important',

      svg: {
        width: '20px',
        height: '20px',
      },
    },
  },

  '.container__rightButtons__maximizedBtn': {
    '&:hover': {
      backgroundColor: '#ededed !important',
      color: '#444 !important',
    },
  },
  '.container__content': {
    p: '20px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    flexGrow: 1,
    overflow: 'auto',
  },
  '.container__footer': {
    display: 'flex',
    justifyContent: 'end',
    boxShadow: 'rgba(100, 98, 88, 0.2) 0px 0px 7px 0px',
    flexShrink: 0,
    p: '10px 15px',
  },
  /* PREPEND HERE */
};
